"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalDateFormatter = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 *
 * @depends buildium.common.Locale
 * @depends manager.framework.common.Settings
 *
 */

var LocalDateFormatter = exports.LocalDateFormatter = function exports(Locale, Settings) {
  return function formatFn(input, format) {
    var momentTime, localZone;

    //if it has a time in the ISO string, then account for timezone and format without time part
    if (typeof input === 'string' && input.indexOf('T') > 0) {
      var reverseSign = -1; //Reverse sign to get same behavior of moment.zone()
      momentTime = (0, _momentTimezone["default"])(input);
      localZone = momentTime.utcOffset() * reverseSign * 60 * 1000;
      //Old dates that are not in the same DST state as now are off by an hour
      momentTime.add(localZone + Settings.SubscriberSettingsInfo.TimeZoneOffset, 'milliseconds');
      return Locale.formatDate(new Date(momentTime), format);
    } else {
      return Locale.formatDate(input, format);
    }
  };
};
LocalDateFormatter.$inject = ['Locale', 'Settings'];